import { getLayer } from './popupStack';

const tooltipElements = new WeakMap();
const tooltipTimeouts = new WeakMap();

export const tooltipDirective = {
  bind(el, binding) {
    const text = binding.value;
    if (!text) return;

    var placement = 'top';
    if (Object.keys(binding.modifiers).length > 0) {
      const validPlacements = ['top', 'bottom', 'left', 'right'];
      for (const mod in binding.modifiers) {
        if (validPlacements.includes(mod)) {
          placement = mod;
          break;
        }
      }
    }
    var delayed = true;
    if (Object.keys(binding.modifiers).includes('instant')) delayed = false;

    const mouseEnterHandler = () => {
      if (tooltipElements.has(el)) return;

      const tooltip = document.createElement('div');
      tooltip.className = `ks-tooltip ks-tooltip-${placement}`;
      tooltip.innerHTML = `
        <div class="ks-tooltip-arrow"></div>
        <div class="ks-tooltip-inner">${binding.value}</div>
      `;

      getLayer('tooltip-layer').appendChild(tooltip);
      tooltipElements.set(el, tooltip);

      // 2. Lasketaan sijainti (TÄRKEÄ VAIHE)
      const rect = el.getBoundingClientRect();
      const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      let top = 0;
      let left = 0;

      switch (placement) {
        case 'top':
          top = scrollTop + rect.top - tooltip.offsetHeight - 8; // 8px väliä elementtiin
          left = scrollLeft + rect.left + (rect.width / 2) - (tooltip.offsetWidth / 2);
          break;
        case 'bottom':
          top = scrollTop + rect.bottom + 8;
          left = scrollLeft + rect.left + (rect.width / 2) - (tooltip.offsetWidth / 2);
          break;
        case 'left':
          top = scrollTop + rect.top + (rect.height / 2) - (tooltip.offsetHeight / 2);
          left = scrollLeft + rect.left - tooltip.offsetWidth - 8;
          break;
        case 'right':
          top = scrollTop + rect.top + (rect.height / 2) - (tooltip.offsetHeight / 2);
          left = scrollLeft + rect.right + 8;
          break;
      }

      tooltip.style.top = `${top}px`;
      tooltip.style.left = `${left}px`;
    };

    const mouseLeaveHandler = () => {
      const tooltip_timeout = tooltipTimeouts.get(el);
      if (tooltip_timeout) {
        clearTimeout(tooltip_timeout);
        tooltipTimeouts.delete(el);
      }
      const tooltip = tooltipElements.get(el);
      if (tooltip) {
        tooltip.remove();
        tooltipElements.delete(el);
      }
    };

    el.__vueTooltipEnter__ = mouseEnterHandler;
    el.__vueTooltipLeave__ = mouseLeaveHandler;

    if (delayed == true) {
      el.addEventListener('mouseenter', () => {
        var timeout_id = setTimeout(() => {
          mouseEnterHandler();
        }, 500); // 500ms viive ennen tooltipin näyttämistä
        tooltipTimeouts.set(el, timeout_id);
      });
    } else {
      el.addEventListener('mouseenter', mouseEnterHandler);
    }
    el.addEventListener('mouseleave', mouseLeaveHandler);
  },

  update(el, binding) {
    if (binding.value !== binding.oldValue) {
      const tooltip = tooltipElements.get(el);
      if (tooltip) {
        tooltip.querySelector('.ks-tooltip-inner').innerHTML = binding.value;
      }
    }
  },

  unbind(el) {
    if (el.__vueTooltipLeave__) {
      el.__vueTooltipLeave__();
    }
    el.removeEventListener('mouseenter', el.__vueTooltipEnter__);
    el.removeEventListener('mouseleave', el.__vueTooltipLeave__);
    delete el.__vueTooltipEnter__;
    delete el.__vueTooltipLeave__;
  }
};